import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutBreBFormContainerComponent } from './components/checkout-bre-b-form-container/checkout-bre-b-form-container.component';

@Component({
  selector: 'angular-monorepo-checkout-form-bre-b',
  standalone: true,
  imports: [CommonModule, CheckoutBreBFormContainerComponent],
  templateUrl: './checkout-form-bre-b.component.html',
  styleUrl: './checkout-form-bre-b.component.scss',
})
export class CheckoutFormBreBComponent {}

